export const data = {
  name: "ReactifyPortfolio",
  city: "Recife",
  slogan:
    "In the project directory, navigate to /src/utils/data.\nOpen the data.js file to edit this template.",
  avatar: "https://avatars.githubusercontent.com/u/74429277?s=96&v=4",
  logosGridSize: 17,
  logosHeroSize: 25,
  socialMedia: [
    {
      name: "twitter",
      url: "https://twitter.com/jdaniel_ap",
      background: "#00acee",
    },
    {
      name: "facebook",
      background: "#4267B2",
    },
    {
      name: "github",
      url: "https://github.com/jdaniel-ap",
      background: "#333333",
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/esoja/",
      background: "#0e76a8",
    },
    {
      name: "discord",
      background: "#7289DA",
    },
    {
      name: "youtube",
      background: "#cc181e",
    },
    {
      name: "instagram",
      background: "#E1306C",
    },
    {
      name: "pinterest",
      background: "#c8232c",
    },
  ],
  tools: [
    "gitlab",
    "bitbucket",
    "mongodb",
    "mysql",
    "postgresql",
    "sqlite",
    "google-firebase",
    "aws-dynamodb",
    "nodejs",
    "prisma",
    "sequelize",
    "npm",
    "yarn",
    "babel",
    "webpack",
    "javascript",
    "typescript",
    "html5",
    "css3",
    "bootstrap",
    "sass",
    "react",
    "redux",
    "dart",
    "python",
    "google-play",
    "react-native",
  ],
  details: {
    about:
      "Living in the lovely city of Recife, I work as a web developer on DR. I am passionate about creating amazing tools that help people achieve their goals. I am constantly learning new skills and keeping up with the latest technology trends to stay ahead of the game. As a dedicated and skilled developer, I take pride in my work and strive to make a positive impact on the industry. With my passion and commitment, I am confident that I can create innovative solutions that make a difference.",
    goals:
      "my goals are to continuously expand my skill set and stay up-to-date with the latest industry trends. I aim to become an expert in new and emerging technologies",
    experience:
      "As a web developer, I have gained extensive experience in designing, building, and maintaining websites and web applications. My expertise in programming languages such as HTML, CSS, JavaScript, and Dart, along with my knowledge of frameworks and tools such as React, Solid, and Node.js, has enabled me to create exceptional web experiences that meet the needs of my clients and users.",
  },
  projects: [
    {
      id: "mais-saude-full",
      title: "Doctor+",
      subtitle: "The simple way to manage your health",
      image: "/images/logos/projects/1.svg",
      color: "#20e0ad",
      details: {
        overview:
          "Doctor+ is an app was designed to making it easy for patients to manage appointments and communicate with healthcare providers. With an intuitive interface and helpful features, the app improves the patient experience.",
        approach:
          "The team, consisting of healthcare professionals and tech experts, collaborated closely during the development. An agile approach allowed for quick iterations and feedback, delivers a seamless and intuitive product for all users.",
        role: "In the Mais Saúde initiative, I held a dual role involving project management and technical contribution. As the Project Manager, I was responsible for ensuring the efficient coordination of the development team, managing project timelines, and overseeing the overall progress. While project management was my primary focus, I also made valuable coding contributions, particularly in critical areas. Moreover, I played a pivotal role in the code review and approval process, ensuring that the team's output adhered to our project goals and coding standards.",
        tools:
          "Doctor+ was developed using a range of technologies that were carefully selected to ensure that the app met our standards for functionality, performance, and user experience. We used React to build a user-friendly and responsive front-end that could be used on different devices.\n\nFor the app's backend, we leveraged the cloud-based services provided by Firebase to handle server-side logic and integrate with third-party services. Firebase also provided the authentication and real-time database features that were essential for the app's functionality. These technologies played a key role in the development of Doctor+ and enabled us to deliver an app that exceeded our users' expectations.",
      },
    },
    {
      id: "pinPoint-front",
      title: "PinPoint",
      subtitle: "Study and organize in one place",
      image: "/images/logos/projects/2.svg",
      color: "#4231AC",
      details: {
        overview:
          "PinPoint is a studying app for medical professionals seeking to revalidate their degrees. The app offers features like study planning, an agenda, quizzes, quiz maker, performance statistics, and relevant information to help users stay organized and on track.",
        approach:
          "Throughout the development, the team employed an agile methodology. User feedback was consistently incorporated throughout the development process to improve the app's usability.",
        role: "As a co-founder, I was involved in multiple aspects of the project's development. I contributed to the app's design and branding, ensuring that it aligned with our vision.\n\nAs a developer, I helped to build the app and collaborated closely with the team to ensure that it met our standards for functionality and performance. Throughout the development process, I provided feedback and made suggestions to improve the app's usability and responsiveness.",
        tools:
          "The app was built using a range of technologies that were carefully selected. We chose to use React Native to build the app because our team was familiar with the technology and its libraries, and we believed it would enable us to develop the app more quickly.\n\nFor the app's backend, we used Node to handle server-side logic and integrate with third-party services, and we leveraged serverless technologies to improve scalability and reduce infrastructure overhead.\n\nWe also leveraged C# to scrape information from the official test PDFs and inject it into the app.",
      },
      assets: [
        "/images/projects/revalidei1.jpeg",
        "/images/projects/revalidei2.jpeg",
        "/images/projects/revalidei3.jpeg",
        "/images/projects/revalidei4.jpeg",
        "/images/projects/revalidei5.jpeg",
        "/images/projects/revalidei6.jpeg",
      ],
    },
    {
      id: "border",
      title: "Border",
      image: "/images/logos/projects/3.svg",
      color: "#F05A22",
      details: {
        overview:
          "DR is a software development company based in São Paulo that specializes in designing, developing, and implementing software applications for various industries and sectors.\n\nThe company employs skilled software developers and uses agile development methodologies to ensure timely delivery of customized solutions to clients.",
        approach:
          "Working at DR is rewarding and challenging. The team is skilled and collaborative, and agile methodologies ensure timely project delivery. The company culture is supportive and innovative, fostering professional growth and development.",
        role: "As a full stack dev I work closely with the team to design, develop, test, and deploy software solutions that meet client needs and requirements. My expertise in front-end development helps ensure that the user interface is intuitive and easy to use.\n\nI also work on back-end development tasks, integrating with databases and APIs to create full-stack solutions. Overall, my role is essential in creating innovative and customized software solutions that drive the success of the company and its clients.",
        tools:
          "I utilize a range of tools to develop high-quality software solutions, including React, Node, Postgress, MongoDB, Firebase and React Native. These tools allow me to build dynamic and responsive applications for multiple platforms and deliver customized solutions that meet client needs. By using these powerful technologies, I can create innovative and customized software solutions that drive the success of our clients' businesses.",
      },
    },
    {
      id: "clues-hackathon",
      title: "Clues",
      subtitle: "Streamlining pet care",
      image: "/images/logos/projects/5.svg",
      color: "#BA68C8",
      details: {
        overview:
          "Clues is a pet management app for stray and owned pets, offering health tracking, vet scheduling, and lost/found services. It was developed by the JabutiTeam for a Hackathon hosted by Recife Hall and Sebraes",
        approach:
          "Clues aims to streamline pet management by providing a comprehensive platform for both stray and owned pets. By offering features such as health tracking, vet scheduling, and lost/found services, the app helps to ensure the well-being of all pets while increasing the chances of stray pets finding homes. Clues strives to make pet ownership and care as convenient and stress-free as possible.",
        role: "As a software engineer on Clues, I designed, developed and debugged features, collaborating with the team to identify and overcome technical challenges. I provided guidance to junior engineers and contributed to the app's design and architecture.",
        tools:
          "We used Flutter, a mobile app development framework, and Firebase, a backend platform, to create Clues. Flutter enabled us to build natively compiled apps for Android and iOS with a single codebase, while Firebase provided real-time data syncing, user authentication, and app analytics. This technology stack allowed us to create a fast, reliable, and scalable app that met the needs of our users.",
      },
      assets: [
        "/images/projects/petxus1.png",
        "/images/projects/petxus2.png",
        "/images/projects/petxus3.png",
        "/images/projects/petxus4.png",
        "/images/projects/petxus5.png",
        "/images/projects/petxus6.png",
        "/images/projects/petxus7.png",
        "/images/projects/petxus8.png",
        "/images/projects/petxus9.png",
        "/images/projects/petxus10.png",
      ],
    },
    {
      id: "leafe",
      title: "Leafe",
      subtitle: "Manage your appointments",
      image: "/images/logos/projects/4.svg",
      color: "#4f46e5",
      details: {
        overview:
          "Leafe is a web application designed to facilitate seamless connections between professionals and patients for appointment scheduling and management. Geared towards enhancing efficiency and convenience, this platform serves as a central hub where professionals from various fields can coordinate their availability and patients can easily access and book appointments.",
        approach:
          "The journey of Leafe was guided by an agile methodology. We valued user input at every step, iteratively enhancing the app's usability. By continuously integrating user feedback, creating a meaningful and efficient experience for all.",
        role: "During my time as a project manager at Leafe, I led the development journey, coordinated team efforts, and ensured the timely delivery features. I also contributed coding, where I implemented some features.",
        tools:
          "Our tech stack encompasses React for dynamic front-end, Node.js and Express for efficient server-side handling, and PostgreSQL for secure data management. These tools synergize to empower Leafe, delivering a seamless platform.",
      },
    },
    {
      id: "vision",
      title: "Vision",
      subtitle: "Patient Data at Your Fingertips",
      image: "/images/logos/projects/6.svg",
      color: "#7158e2",
      details: {
        overview:
          "Vision is a specialized mobile app designed for medical professionals. It simplifies access to crucial patient data, streamlining their workflow. With the app Healthcare providers can efficiently manage and retrieve essential information, enhancing the quality of patient care.",
        approach:
          "The development of Vision followed an agile methodology, with a strong emphasis on user-centric design. Throughout the process, the team continually refined the app's usability to ensure it provided a seamless and efficient experience tailored exclusively for medical professionals.",
        role: "In the development of Vision, I assumed a dual role as both the primary Software Engineer and the Project Manager. This allowed me to contribute directly to the app's technical aspects while also overseeing the project's successful execution. This comprehensive approach ensured that Vision was tailored effectively to meet the unique needs of medical professionals.",
        tools:
          "We harnessed two essential tools, Flutter and Firebase, in the creation of this platform. Flutter, a versatile and powerful framework, provided the foundation for building a dynamic and responsive user interface, offering a seamless experience for both medical professionals and patients. Meanwhile, Firebase played a pivotal role as the backend infrastructure, enabling secure data storage, efficient data retrieval, and real-time updates. This robust technology duo formed the backbone of our application, playing a critical role in bringing this essential tool to life for medical professionals.",
        "P.D":
          "This app is currently in the development process. Our team committed to creating a user-friendly, feature-rich application that will cater to the needs and exceed the expectations.\n\nDuring this development phase, we're actively refining the app's functionalities, design elements, and user interface. We're also rigorously testing the application to ensure it meets the highest standards of quality and performance.",
      },
      links: {
        demo: "https://www.google.com",
        repository: "https://www.google.com",
      },
      assets: [
        "/images/projects/upacient1.png",
        "/images/projects/upacient2.png",
        "/images/projects/upacient3.png",
        "/images/projects/upacient4.png",
        "/images/projects/upacient5.png",
        "/images/projects/upacient6.png",
        "/images/projects/upacient7.png",
      ],
    },
  ],
};
